// extracted by mini-css-extract-plugin
export default {"noiseGraf":"NoizeGraf_noiseGraf__fbpxl","noiseCanvas":"NoizeGraf_noiseCanvas__hX579"};